import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the first CTA has scrolled out of view upward
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 px-3 pb-3 transition-[opacity,transform] duration-200 ease-out sm:px-6 sm:pb-5 ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'}`} data-id="element-31" data-mp="go18jo84z26j">
      <div className="mx-auto max-w-lg" data-id="element-32" data-mp="14eyac867wj42">
        <a href={CHECKOUT_URL} className={`flex items-center justify-center gap-2 rounded-2xl bg-grass-500 px-4 py-4 text-center text-[14px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_8px_24px_rgba(13,34,64,0.35)] transition-colors duration-200 ease-out hover:bg-grass-400 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-grass-400/40 sm:text-base ${visible ? 'animate-shake' : ''}`} data-id="element-33" data-mp="14dvls6wdasrb">
          <span data-id="element-34" data-mp="1rdomml44y8s7">Get instant access — $27</span>
          <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-35" data-mp="1wdjb6i0fuma3" />
        </a>
      </div>
    </div>;
}